import { Action } from '@ngrx/store';
import * as models from '../../domain/models';
import * as viewModels from '../../view/view-models';

export const LOAD = '[RM Generic Floor Plan Collection] Load';
export const LOAD_SUCCESS = '[RM Generic Floor Plan Collection] Load Success';
export const LOAD_FAIL = '[RM Generic Floor Plan Collection] Load Fail';
export const RESET = '[RM Generic Floor Plan Collection] Reset';


export class LoadPayload {
  constructor(public lookup: viewModels.FloorPlansLookup) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public items: Array<models.GenericFloorPlan>, public total: number) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction | ResetAction;
